import { TmWorkerError } from '@/core/error/worker/TmWorkerError'

export class TmQrCodeWorkerError extends TmWorkerError {
  public name = 'TmQrCodeWorkerError'
}
